/**
 * Appends `px` to bare numbers in an authored CSS length so authors can type
 * `12` or `8 0` instead of `12px` / `8px 0`. Tokens that already carry a unit,
 * a percentage, or a keyword (`auto`, `inherit`) are left untouched.
 * @param value - The authored value ("" when unset)
 * @returns The value with bare numbers expressed in px
 */
export function withDefaultPxUnits(value: string): string {
  return value
    .trim()
    .split(/\s+/)
    .map((token) => (/^-?\d*\.?\d+$/.test(token) ? `${token}px` : token))
    .join(" ");
}
